import { useLanguage } from '@/i18n/LanguageContext';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Button } from '@/components/ui/button';
import { Globe } from 'lucide-react';
import { useState } from 'react';

export function LanguageSwitcher({ className = "" }) {
  const { language, setLanguage, languages } = useLanguage();
  const [open, setOpen] = useState(false);
  const currentLang = languages.find(l => l.code === language);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className={`flex items-center gap-1.5 px-2 py-1 h-auto ${className}`}
          data-testid="language-switcher-btn"
        >
          <span className="text-lg leading-none">{currentLang?.flag}</span>
          <span className="text-xs font-medium hidden sm:inline">{currentLang?.code?.toUpperCase()}</span>
          <Globe className="w-3.5 h-3.5 opacity-60" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-44 p-1" align="end">
        {languages.map(lang => (
          <button
            key={lang.code}
            onClick={() => { setLanguage(lang.code); setOpen(false); }}
            className={`w-full flex items-center gap-2.5 px-3 py-2 rounded-md text-sm transition-colors hover:bg-accent ${
              language === lang.code ? 'bg-accent font-semibold' : ''
            }`}
            data-testid={`lang-option-${lang.code}`}
          >
            <span className="text-lg leading-none">{lang.flag}</span>
            <span>{lang.name}</span>
          </button>
        ))}
      </PopoverContent>
    </Popover>
  );
}
